
<template>
    <div class="OperateNavTable">
        <div v-for="(pack,unit) in [['5','6','7','8','9'],['全包','','','','']]" class="l-flex o-mt">
            <template v-for="(item,index) in pack">
                <div v-if="index" style="padding:0 .2rem;" />
                <div class="l-flex-1">
                    <div v-if="item">
                        <div class="row-title c-text-c">{{ item }}</div>
                        <group :client="client" :list="Table[unit * 5 + index + 1]" :length="1" />
                    </div>
                </div>
            </template>
        </div>
        <BoardFast :client="client" :group="TableAll" :step="true" :default-step="0.1" />
    </div>
</template>

<script>
import CommonMix from '../common.js'
import Group from '../group.vue'
export default {
    name: 'OperateDpc14',
    mixins: [CommonMix],
    props: {
        client: {}
    },
    components: {
        Group
    }
}
</script>
